import { AfterViewInit, DestroyRef, Directive, ElementRef, HostBinding, Inject, OnInit, inject } from '@angular/core';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { startWith } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Directive to add custom styles to the dots of the carousel
 * in the carousel options, set dots: true and autoWidth: true for this directive to work.
 * overrides the default dot behavior of the owl-carousel to scroll 1 dot per 1 item
 */
@Directive({
  selector: 'owl-carousel-o',
})
export class CustomOwlCarousel implements AfterViewInit, OnInit {
  private _isCustom: boolean;
  private _destoryRef: DestroyRef = inject(DestroyRef);
  @HostBinding('class.owl-custom') get customClass() {
    return this._isCustom;
  }

  constructor(@Inject(CarouselComponent) private carousel: CarouselComponent, private _el: ElementRef) { }

  ngOnInit(): void {
    const options = this.carousel.options;
    if (options.dots && options.autoWidth) {
      this._isCustom = true;
    }
  }

  ngAfterViewInit(): void {
    this.carousel.changed
      .pipe(startWith({ startPosition: 0 }), takeUntilDestroyed(this._destoryRef))
      .subscribe(({ startPosition }) => {
        if (this.carousel?.options?.dots && this.carousel?.options?.autoWidth) {
          const position = startPosition || 0;
          const dotsContainer = this._el.nativeElement.getElementsByClassName('owl-dots')[0] as HTMLDivElement;
          const dots = this._el.nativeElement.getElementsByClassName('owl-dot') as HTMLCollectionOf<HTMLDivElement>;

          if (dotsContainer) {
            const containerWidth = dotsContainer.offsetWidth;
            const dotWidth = dots.item(position)?.offsetWidth || 0;
            const start = dotsContainer.scrollLeft;
            const scrollPosition = (position * dotWidth) - start;
            
            const duration = 200; // Duration in milliseconds
            let startTime: number | null = null;
            const anim = (t: number) => {
              return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; 
            };

            const animateScroll = (currentTime: number) => {
              if (startTime === null) startTime = currentTime;

              const elapsedTime = currentTime - startTime;
              const x = Math.min(elapsedTime / duration, 1); 
              const animate = anim(x); 

              dotsContainer.scrollLeft = start + (scrollPosition - (containerWidth /2) + (dotWidth /2)) * animate;

              if (x < 1) {
                requestAnimationFrame(animateScroll);
              }
            };

            requestAnimationFrame(animateScroll);
          }
        }
      });
  }
}
